export const isRussia = (value: string) => {
	return (
		value.toLocaleLowerCase() === 'российская федерация' ||
		value.toLocaleLowerCase() === 'russian federation' ||
		value.toLocaleLowerCase() === 'russia' ||
		value.toLocaleLowerCase() === 'россия'
	);
};
